/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./orders.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import {
  ActivateIcon,
  AutoActivatedIcon,
  ResendEmailIcon,
} from "../../../component/icons/icons";
import Chip from "@mui/material/Chip";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../../helper/numberFormatter";
import {formatDate} from "../../../helper/dateFormatter";

const OrderTable = (props) => {
  const navigate = useNavigate();
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table + " " + "newGlobalTable"}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                style={{ width: "12%" }}
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{props.t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {/* {props.sortOrder === 'DESC' ? 'expand_less' : 'expand_more'} */}

                    {/* sometimes during page load expand_less or expand_more would show up beside table headers and would not look good */}
                    {props.sortOrder === "DESC" ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.view !== "ordersByCustomer" && (
                <>
                  {props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                    props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                      <TableCell
                        className="global-custom-sorting-header"
                        onClick={(e) => {
                          props.updateSorting("customerName");
                        }}
                      >
                        <b>{props.t("CUSTOMER_NAME")}</b>
                        {/* Sort indication */}
                        {props.sortBy === "customerName" ? (
                          <span className="material-icons">
                            {props.sortOrder === "DESC"
                              ? "expand_less"
                              : "expand_more"}
                          </span>
                        ) : (
                          <span className="material-icons sorting-indicator-icon">
                            unfold_more
                          </span>
                        )}
                      </TableCell>
                    )}
                  {props.providerType === "SALES_CHNL_PROVIDER" &&
                    (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                      <TableCell>
                        <b>{props.t("CUSTOMER_BAN")}</b>
                      </TableCell>
                    )}
                </>
              )}
              <TableCell>
                <b>{props.t("TYPE")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderDate");
                }}
              >
                <b>{props.t("ORDER_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell>
                <b>{props.t("STATUS")}</b>
              </TableCell>

              {props.controls && (
                <TableCell align="center">
                  <b>{props.t("ACTION")}</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.orders.map((row) => (
              <TableRow
                key={row.orderId}
                hover
                className={classes.rowClass + " " + "orderTableRow"}
                onClick={(e) => {
                  e.stopPropagation();
                  props.providerType === "SOLUTION_PROVIDER"
                    ? navigate(
                        `/order/${row.orderId}?tenantId=${props.tenantId}`,
                      )
                    : navigate(`/order/${row.orderId}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {row.orderId}
                </TableCell>
                {props.view !== "ordersByCustomer" &&
                  props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                  props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                    <>
                      <TableCell>
                        {row.accountName
                          ? row.accountName
                          : row.customer.accountName}
                      </TableCell>
                      {props.providerType === "SALES_CHNL_PROVIDER" && (
                        <TableCell>
                          {row.ban ? row.ban : row.customer.ban}
                        </TableCell>
                      )}
                    </>
                  )}
                <TableCell>
                  {row.typeDescription ? (
                    row.typeDescription
                  ) : (
                    <>
                      {/* {row.type === 'NewActivation' && props.t('NEW')}
                                                {row.type === 'ShiftSubscription' && props.t('Shift')}
                                                {row.type === 'ChangeSubscription' && props.t('CHANGE')}
                                                {row.type === 'CancelSubscription' && props.t('CANCEL')} */}
                      {row.orderId.substring(0, 2) === "SO" &&
                        props.t("NEW_ACTIVATION")}
                      {row.orderId.substring(0, 2) === "CH" &&
                        props.t("CHANGE_SUBSCRIPTION")}
                      {row.orderId.substring(0, 3) === "TOI" &&
                        props.t("TERMINATE_SUBSCRIPTION")}
                      {row.orderId.substring(0, 3) === "SHI" &&
                        props.t("SHIFT_SUBSCRIPTION")}
                    </>
                  )}
                </TableCell>
                <TableCell>
                  {props.controls ? (
                    ""
                  ) : (
                    <IconButton style={{ minHeight: "32px" }}></IconButton>
                  )}
                  {formatDate(row.orderDate)}
                </TableCell>
                <TableCell>
                  {/* {row.orderStatus} */}
                  {row.orderStatus === "Order Fulfilled" ? (
                    <Chip
                      size="normal"
                      className="successChip"
                      label={props.t(row.orderStatus)}
                    />
                  ) : (
                    <Chip
                      size="normal"
                      className="inProgressChip"
                      label={props.t(row.orderStatus)}
                    />
                  )}
                </TableCell>
                {props.controls && (
                  <>
                    {props.providerType === "SALES_CHNL_PROVIDER" ? (
                      <TableCell
                        align="right"
                        onClick={(e) => {
                          e.stopPropagation();
                          (row.orderStatus === "Waiting Customer Acceptance" ||
                            row.orderStatus ===
                              "Waiting For Customer Acceptance") &&
                            props.openResendDialog(row.orderId);
                          (row.orderActivationStatus ===
                            "Ready For Activation" ||
                            row.orderActivationStatus ===
                              "Partially Activated" ||
                            row.orderActivationStatus === "Activated") &&
                            navigate(`/activate/${row.orderId}`);
                        }}
                      >
                        {row.orderStatus === "Waiting Customer Acceptance" ||
                        row.orderStatus ===
                          "Waiting For Customer Acceptance" ? (
                          <Tooltip
                            title={props.t("RE_SEND")}
                            className={classes.tooltipCustom}
                          >
                            <IconButton>
                              <ResendEmailIcon />
                              {/* <ResendEmailIcon onClick={(e) => { e.stopPropagation(); props.openResendDialog(row.orderId) }} /> */}
                            </IconButton>
                          </Tooltip>
                        ) : row.autoActivatable ? (
                          <Tooltip
                            title={props.t("AUTO_ACTIVATED")}
                            className={classes.tooltipCustom}
                          >
                            <IconButton>
                              <AutoActivatedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : row.orderActivationStatus ===
                            "Ready For Activation" ||
                          row.orderActivationStatus === "Partially Activated" ||
                          row.orderActivationStatus === "Activated" ? (
                          <Tooltip
                            title={props.t("ACTIVATE")}
                            className={classes.tooltipCustom}
                          >
                            <IconButton>
                              <ActivateIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <IconButton
                            style={{ minHeight: "32px" }}
                          ></IconButton>
                        )}
                      </TableCell>
                    ) : (
                      <>
                        <TableCell
                          align="right"
                          onClick={(e) => {
                            e.stopPropagation();
                            (row.orderActivationStatus ===
                              "Ready For Activation" ||
                              row.orderActivationStatus ===
                                "Partially Activated" ||
                              row.orderActivationStatus === "Activated") &&
                              navigate(
                                `/activate/${row.orderId}?tenantId=${props.tenantId}`,
                              );
                          }}
                        >
                          {row.autoActivatable ? (
                            <Tooltip
                              title={props.t("AUTO_ACTIVATED")}
                              className={classes.tooltipCustom}
                            >
                              <IconButton>
                                <AutoActivatedIcon />
                              </IconButton>
                            </Tooltip>
                          ) : row.orderActivationStatus ===
                              "Ready For Activation" ||
                            row.orderActivationStatus ===
                              "Partially Activated" ||
                            row.orderActivationStatus === "Activated" ? (
                            <Tooltip
                              title={props.t("ACTIVATE")}
                              className={classes.tooltipCustom}
                            >
                              <IconButton>
                                <ActivateIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <IconButton
                              style={{ minHeight: "32px" }}
                            ></IconButton>
                          )}
                        </TableCell>
                      </>
                    )}
                  </>
                )}
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.showLoading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {props.t("LOADING")}
                </TableCell>
              </TableRow>
            )}
            {!props.showLoading && props.orders.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {props.t("NO_ORDER_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalOrderCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalOrderCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(props.totalOrderCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(OrderTable);
